export class CallbackType {
    /** @type {"ErrorCallback"} */
    static ErrorCallback = "ErrorCallback";
    /** @type {"EmptyRequestCallback"} */
    static EmptyRequestCallback = "EmptyRequestCallback";
    /** @type {"RequestNumberCallback"} */
    static RequestNumberCallback = "RequestNumberCallback";
    /** @type {"RequestBooleanCallback"} */
    static RequestBooleanCallback = "RequestBooleanCallback";
    /** @type {"RequestTableCallback"} */
    static RequestTableCallback = "RequestTableCallback";
    /** @type {"LoadDocumentCallback"} */
    static LoadDocumentCallback = "LoadDocumentCallback";
    /** @type {"SaveDocumentResultCallback"} */
    static SaveDocumentResultCallback = "SaveDocumentResultCallback";
    /** @type {"RequestTableCellCallback"} */
    static RequestTableCellCallback = "RequestTableCellCallback";
    /** @type {"RequestStringCallback"} */
    static RequestStringCallback = "RequestStringCallback";
    /** @type {"AddSubTextPartCallback"} */
    static AddSubTextPartCallback = "AddSubTextPartCallback";
    /** @type {"RequestSubTextPartCallback"} */
    static RequestSubTextPartCallback = "RequestSubTextPartCallback";
    /** @type {"RequestApplicationFieldCallback"} */
    static RequestApplicationFieldCallback = "RequestApplicationFieldCallback";
    /** @type {"RequestObjectCallback"} */
    static RequestObjectCallback = "RequestObjectCallback";
    /** @type {"RequestStringsCallback"} */
    static RequestStringsCallback = "RequestStringsCallback";
    /** @type {"RequestFormFieldCallback"} */
    static RequestFormFieldCallback = "RequestFormFieldCallback";
    /** @type {"AddEditableRegionCallback"} */
    static AddEditableRegionCallback = "AddEditableRegionCallback";

    /** @type {"RequestRectangleCallback"} */
    static RequestRectangleCallback = "RequestRectangleCallback";

    /** @type {"RequestTextCharCallback"} */
    static RequestTextCharCallback = "RequestTextCharCallback";
}